import axios from "axios";

export function getUnprocessMasterListNotification() {
  return new Promise((resolve, reject) => {
    axios
      .get(`/distributor/admin/api/v1/master-list/notification-count-menu`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
